import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ClickableWrap from '../ClickableWrap';
import FixAspect from '../FixedAspect';

import './styles.less';

if (__CLIENT__) {
  require('lazysizes');
}

const renderCaption = (caption, credit) => {
    return (
        <div className="p-image__meta">
            <span className="p-image__caption">{caption}</span>
            {credit ? <span className="p-image__credit">{credit}</span> : null}
        </div>
    );
};

const renderImg = (src, alt) => {
    return (
        <img
            className="lazyload"
            alt={alt}
            data-srcset={
                src.length
                    ? src
                        .map((elem) => {
                            return `${elem.src} ${elem.width}w`;
                        })
                        .reduce((acc, curr) => {
                            return `${acc}, ${curr}`;
                        })
                    : undefined
            }
            data-sizes="auto"
        />
    );
};

const Image = (props) => {
    return (
        <div
            className={classNames({
                'p-image': true,
                [props.className]: props.className
            })}
            style={{
                width: '100%'
            }}
        >
            <FixAspect ratio={props.aspectRatio}>
                <div
                    className={classNames({
                        'p-image__image': true,
                        [`${props.className}_image`]: props.className
                    })}
                    style={{
                        backgroundImage: `url(${require('./image-placeholder.svg')})`,
                        height: '100%',
                        width: '100%'
                    }}
                    data-content-id={props.contentId}
                >
                    <ClickableWrap url={props.url} openInNewTab={props.openInNewTab}>
                        {renderImg(props.cuts, props.alt)}
                    </ClickableWrap>
                </div>
            </FixAspect>
            {props.caption ? renderCaption(props.caption, props.credit) : null}
        </div>
    );
};

Image.propTypes = {
    caption: PropTypes.string,
    credit: PropTypes.string,
    cuts: PropTypes.arrayOf(
        PropTypes.shape({
            width: PropTypes.number,
            src: PropTypes.string
        })
    ),
    className: PropTypes.string,
    aspectRatio: PropTypes.string,
    contentId: PropTypes.string,
    alt: PropTypes.string,
    openInNewTab: PropTypes.bool,
    url: PropTypes.string
};

Image.defaultProps = {
    caption: undefined,
    credit: undefined,
    cuts: [],
    className: undefined,
    aspectRatio: undefined,
    contentId: undefined,
    alt: undefined,
    openInNewTab: false,
    url: undefined
};

export default Image;
